import Flickity from "flickity";

const sliders = document.querySelectorAll(".js-news-slider");

if (sliders) {
  let i = 0;

  while (i < sliders.length) {
    new Flickity(sliders[i], {
      cellAlign: "left",
      groupCells: true,
      contain: false,
      prevNextButtons: true,
      arrowShape:
        "M24.6 9.066L15.572.384A1.386 1.386 0 0014.605 0c-.367 0-.71.136-.968.384l-.82.788c-.257.248-.4.578-.4.93 0 .353.143.694.4.942l5.267 5.076H1.351C.596 8.12 0 8.688 0 9.414v1.114c0 .726.596 1.351 1.35 1.351h16.794l-5.327 5.105c-.257.247-.399.569-.399.921 0 .352.142.679.4.926l.82.786c.257.248.6.383.967.383.366 0 .71-.137.967-.385l9.029-8.682c.258-.248.4-.58.399-.933 0-.354-.141-.686-.4-.934z",
    });
    i++;
  }
}